import { navigateTo, defineNuxtRouteMiddleware } from '#app/composables/router'
import { useShopGenderCookie } from '~/composables/useShopGenderCookie'
import { createError } from '#app/composables/error'
import { useGenderMenuItems } from '~/composables/useGenderMenuItems'
import { useCurrentShop } from '#storefront/composables'
import { useNuxtApp } from '#app'

export default defineNuxtRouteMiddleware((to) => {
  const scope = to?.params?.scope as string
  const { isValidGender } = useGenderMenuItems()
  const validScopes = isValidGender(scope)
  const { t } = useNuxtApp().$i18n

  // redirect 404 if invalid scope is set
  if (scope && !validScopes) {
    throw createError({
      statusCode: 404,
      statusMessage: t('404.scope'),
    })
  }

  // prevent redirecing to the current cookie value on server side
  // Cookie still not available on server side and can cause mismatching hydration
  if (import.meta.server) {
    return
  }
  const { cookie: currentMenu, updateCookie } = useShopGenderCookie()

  const validCurrentMenu = currentMenu.value && isValidGender(currentMenu.value)

  const shopLocale = useCurrentShop()

  // Only redirect to add scope when accessing the homepage (root path)
  if (
    validCurrentMenu &&
    !to.params.scope &&
    (to.path === `/${shopLocale.value.path}` || to.path === '/')
  ) {
    const toQueryParams = to.query
    const queryString = new URLSearchParams(
      toQueryParams as Record<string, string>,
    ).toString()

    updateCookie(currentMenu.value)

    const path = toQueryParams
      ? `/${
          shopLocale.value.path
        }/${currentMenu.value.toLowerCase()}?${queryString}`
      : `/${shopLocale.value.path}/${currentMenu.value.toLowerCase()}`

    return navigateTo(path)
  }
})
